
<template>
    <div>
        <mars-view class="regulate"><mars-view class="top"><top-bar :title="topBar.title" :bg-color="topBar.bgColor" :text-color="topBar.fontColor" :show-list-icon="search_source === 'launch_clause' && activeTab === 0" :no-blank="false" @goRegulationList="searchRegulationQuestion"></top-bar><mars-view class="contanter"><mars-view class="fixed-top"><mars-view class="tab"><mars-view v-for="(item, index) in tab" :key="index" class="tab-item" :class="{'active': activeTab === index}" @click.native="tabClick(index)">
                        {{ item }}
                        <mars-view v-show="activeTab === index" class="select"></mars-view></mars-view></mars-view><mars-view class="c-row bar"><mars-view v-if="activeTab === 0" class="c-span9"><mars-input v-model="currentLawQuery" :placeholder="search_source === 'launch_clause' ? '在法律全文中查询要点...' : '搜索法律法规...'" placeholder-class="placeholder" type="text" @input="watchCurentVaue('currentLawQuery', $event)"></mars-input><mars-view v-show="currentLawQuery" class="clear-btn" @click.native="clearQuery('currentLawQuery')"></mars-view></mars-view><mars-view v-else class="c-span9"><mars-input v-model="currentQaQuery" placeholder="搜索法律问题..." placeholder-class="placeholder" type="text" @input="watchCurentVaue('currentQaQuery', $event)"></mars-input><mars-view v-show="currentQaQuery" class="clear-btn" @click.native="clearQuery('currentQaQuery')"></mars-view></mars-view><mars-view class="c-span3"><mars-view class="btn" @click.native="queryByForm">查询</mars-view></mars-view><mars-view v-if="isShowCatalogue" class="c-span2"><mars-view class="catalogue-btn" @click.native="changeCatalogueShow">
                            目录
                        </mars-view></mars-view></mars-view><mars-view v-show="isSelectshow" class="recommend-select"><mars-view v-for="(item, index) in sugList" :key="index" class="recommend-select-item" @click.native="sugItemClick(item)"><mars-rich-text :nodes="item.text"></mars-rich-text></mars-view></mars-view></mars-view></mars-view></mars-view><mars-view v-show="!isSelectshow" class="content" :style="{
            background: !regulationOtherQuestion ? '#f5f5f5' : '#fff',
        }"><mars-view v-if="activeTab === 0" class="content-articles content_law" :class="{'content_law': search_source === 'launch_clause'}"><mars-scroll-view v-if="!isRegulationLoading" class="scroll-view" scroll-with-animation scroll-y upper-threshold="7" lower-threshold="7" :scroll-into-view="currentMenu" @scrolltolower="bindscrolltolower"><mars-view class="scroll-warpper"><regulation-content v-if="search_source === 'launch_clause'" :law="law" :rules="rules" :remark="remark" :search-title="searchTitle" :content-count="contentCount" @viewOrigin="getLaunch"></regulation-content><regulation-list v-else :class="{'white': !regulations}" :regulations="regulations"></regulation-list><regulations-prompt v-show="!regulationOtherQuestion && search_source === 'launch_clause'" class="regulations-promt" :search-title="searchTitle" :search-source="search_source" :prompt="prompt" :rules="rules" :regulations="regulations" :native-ad="nativeAd" @searchRelatedRegulation="searchRelatedRegulation"></regulations-prompt><other-question v-if="regulationOtherQuestion" type="regulation" :regulation-list="otherRegulationList" :lawyer-count="lawyerCnt" :banner-ad="bannerAd" @searchRegulationQuestion="searchRegulationQuestion"></other-question></mars-view></mars-scroll-view></mars-view><mars-view v-if="activeTab === 1" class="content-qa"><mars-scroll-view v-if="!isQaLoading" class="scroll-view" scroll-y upper-threshold="7" lower-threshold="7" @scrolltolower="onScrollToLower"><qa-content :class="{'white': !qalist, 'has-data': qalist && qalist.length > 0}" :qalist="qalist" :no-qa-result="noQaResult" :no-more-result="noMoreResult" :bottom-loading="bottomLoading"></qa-content><other-question v-if="noQaResult" class="qa-qustion" type="qa" :qa-list="otherQaList" :lawyer-count="lawyerCnt" :banner-ad="bannerAd" @searchQaQuestion="searchQaQuestion"></other-question></mars-scroll-view></mars-view></mars-view><catelogues :is-catalogue-show="isCatalogueShow" :contents="contents" @contentsClick="contentsClick" @changeCatalogueShow="changeCatalogueShow"></catelogues><mars-view class="bottombar"><bottom-bar v-if="serviceBtn" :client-ip="clientIp" :service-button="serviceBtn" :type="1" :light-style="true" :logger-key="activeTab === 1 ? 'qa' : search_source" :compatible-safarea="false" service-type="showConsult" :consult-count="consultCnt"></bottom-bar></mars-view><no-more-pop :show-popup="showNoMorePop" @closePopUp="closePopUp" @turnIm="turnIm('btnUrl')"></no-more-pop></mars-view>
    </div>
</template>

<script>
/* globals swan getApp */
import { reqPathTo, reqPathToSearch } from '../../static/utils/env.js';
import { ubcClickInit, sendUbcShowLog } from '../../static/utils/ubcMethods.js';
import Topbar from "../../components/common/topbar.vue";
import RegulationContent from "../../components/qalandpage/regulations/content.vue";
import regulationsList from "../../components/qalandpage/regulations/regulationsList.vue";
import OtherQuestion from "../../components/qalandpage/regulations/otherQueston.vue";
import BottomBar from "../../components/qalandpage/bottomBar.vue";
import { getData } from '../../static/utils/request.js';
import qaContent from "../../components/qalandpage/regulations/qaContent.vue";
import regulationsPrompt from "../../components/qalandpage/regulations/regulationsPrompt.vue";
import catelogues from "../../components/qalandpage/regulations/catalogues.vue";
import { nav, act } from '../../static/utils/navigate';
import noMorePop from "../../pages/qalandpage/components/noMorePop.vue";
export default {
  components: {
    'top-bar': Topbar,
    'regulation-content': RegulationContent,
    'regulation-list': regulationsList,
    'other-question': OtherQuestion,
    'bottom-bar': BottomBar,
    'qa-content': qaContent,
    'regulations-prompt': regulationsPrompt,
    'catelogues': catelogues,
    'no-more-pop': noMorePop
  },
  data() {
    return {
      word: '',
      // 召回卡的query
      law: {},
      // 法规标题等信息
      rules: [],
      // 章条等内容
      remark: '',
      // 法律修订信息
      contents: [],
      // 章节的目录
      currentMenu: null,
      tab: ['法律法规', '法律知识问答'],
      topBar: {
        title: '法律法规',
        color: '#fff',
        bgColor: '#fff',
        fontColor: '#000'
      },
      sugList: [],
      currentLawQuery: '',
      // 法条query
      currentQaQuery: '',
      // 问答数据query
      qalist: null,
      // 问答数据
      regulations: null,
      // 法规数据
      otherRegulationList: [],
      // 没有数据的话 需要搜索值
      otherQaList: [],
      //  没有问答数据
      prompt: null,
      searchTitle: null,
      // 搜索的值 如果没有值 对应的全篇法规
      type: 'content',
      activeTab: 0,
      isCatalogueShow: false,
      showClearBtn: false,
      isSelectshow: false,
      // 输入下拉框
      pn: 1,
      noMoreResult: false,
      noQaResult: true,
      // 没有问答数据
      bottomLoading: false,
      search_source: 'launch_clause',
      contentCount: 0,
      regulationOtherQuestion: false,
      serviceBtn: null,
      clientIp: '',
      nativeAd: {},
      bannerAd: {},
      lawyerCnt: '',
      consultCnt: '',
      isRegulationLoading: false,
      isQaLoading: false,
      showNoMorePop: false
    };
  },
  computed: {
    isShowCatalogue() {
      return this.contents.length > 0 && this.activeTab === 0 && !this.searchTitle && this.search_source === 'launch_clause';
    }
  },
  methods: {
    // 查看原文
    viewOrigin() {
      this.currentMenu = '';
      this.getLaunch();
    },
    // 监听数据框 触发下拉框（sug）
    watchCurentVaue(val, e) {
      this[val] = e.detail.value;
      // 法条落地页不出sug 问答与法规列表才出sug
      if (this.search_source === 'launch_clause' && this.activeTab === 0) {
        return;
      }
      if (this[val]) {
        this.isSelectshow = true;
        this.getSugList(e.detail.value);
      } else {
        this.isSelectshow = false;
      }
    },
    clearQuery(key) {
      this[key] = '';
    },
    searchRelatedRegulation(bool) {
      if (this.search_source === 'launch_clause') {
        nav({
          url: `/pages/qalandpage/regulations?query=${this.currentLawQuery || this.word}&searchSource=launch_law`
        });
      } else {
        this.emitRelatedRegulation(bool);
      }
    },
    // 触发搜索
    emitRelatedRegulation(bool) {
      this.regulationOtherQuestion = bool;
      // 请求法规数据
      this.$api.request({
        url: this.otherRegulationUrl
      }).then(res => {
        try {
          this.otherRegulationList = res.data.data;
        } catch (e) {}
      });
    },
    // 触发问答搜索
    searcOtherQa() {
      this.$api.request({
        url: this.otherQaUrl
      }).then(res => {
        try {
          this.otherQaList = res.data.data;
          this.$mpUpdated(() => {
            this.$mp && this.$mp.scope && this.$mp.scope.removeSkeleton && this.$mp.scope.removeSkeleton();
          });
        } catch (e) {}
      });
    },
    formatQalist(list = [], query = '') {
      return list.map(item => {
        item.qaQuestion = item.qaQuestion.replace(new RegExp(query, 'g'), `<em class="dynamic">${query}</em>`);
        return item;
      });
    },
    // 获取问答数据
    getQalist() {
      const {
        queueResourceId = 8893,
        srcid = 5806
      } = this.queryParams;
      const data = {
        query: this.currentQaQuery,
        srcid: srcid,
        queueResourceId: queueResourceId,
        pn: this.pn,
        rn: 10
      };
      this.isQaLoading = true;
      getData({
        url: this.qalistUrl,
        data,
        loginNeeded: false
      }).then(data => {
        this.isQaLoading = false;
        try {
          let {
            list,
            query
          } = data;
          if (list.length < 10) {
            this.noMoreResult = true;
          }
          if (!list || list.length === 0) {
            this.noQaResult = true;
            this.bottomLoading = false;
            // 如果没有数据的话
            this.searcOtherQa();
          } else {
            this.noQaResult = false;
            this.pn += 1;
          }
          this.qalist = this.formatQalist(list, query);
        } catch (e) {}
      });
    },
    // 搜索其他法规问题
    searchRegulationQuestion(query) {
      // 跳出页面
      nav({
        url: `/pages/qalandpage/regulations?query=${query || this.word}&searchSource=launch_law`
      });
    },
    // 搜索问答数据
    searchQaQuestion(query) {
      this.currentQaQuery = query;
      this.pn = 1;
      this.noMoreResult = false;
      this.getQalist();
      this.$nextTick(() => {
        this.isSelectshow = false;
      });
    },
    // 下拉框推荐数据
    getSugList(query) {
      return this.$api.request({
        url: this.sugUrl,
        data: {
          sug_source: this.activeTab === 0 ? 'rule' : 'qa',
          query
        }
      }).then(res => {
        try {
          let {
            sug_list
          } = res.data.data;
          if (Array.isArray(sug_list)) {
            this.sugList = sug_list.map(item => {
              let obj = {
                query: item,
                text: item.replace(new RegExp(query, 'g'), `<em class="query-strong">${query}</em>`)
              };
              return obj;
            });
          }
        } catch (e) {}
      });
    },
    // 获取法规数据
    getLaunch() {
      const {
        lawid = '5f21fd1e3684b3f4cba1d24720c4adbd_law_clause'
      } = this.queryParams;
      this.isRegulationLoading = true;
      const data = {
        query: this.currentLawQuery || this.word,
        lawid
      };
      return getData({
        url: reqPathTo('regulation/launch', data, '', 'law'),
        loginNeeded: false
      }).then(data => {
        this.isRegulationLoading = false;
        this.rules = data.rules;
        Object.assign(this, data);
        this.law.dynamicTag = this.getDynamicTag(this.law.timeliness_type);
        this.searchTitle = null;
      });
    },
    // 底部咨询所需要的数据
    getSetting() {
      return this.$api.request({
        url: this.settingUrl,
        data: {
          page_from: 'regulation'
        }
      }).then(res => {
        try {
          let {
            service_button,
            client_ip,
            native_ad,
            banner_ad,
            lawyer_cnt,
            consult_cnt
          } = res.data.data;
          this.serviceBtn = service_button;
          this.clientIp = client_ip;
          this.nativeAd = native_ad;
          this.bannerAd = banner_ad;
          this.lawyerCnt = lawyer_cnt;
          this.consultCnt = consult_cnt;
        } catch (e) {}
      });
    },
    updateQaList() {
      // 异步请求律师
      const {
        queueResourceId = 8893,
        srcid = 5806
      } = this.queryParams;
      const data = {
        query: this.currentQaQuery || this.word,
        srcid: srcid,
        queueResourceId: queueResourceId,
        pn: this.pn,
        rn: 10
      };
      return this.$api.request({
        url: this.qalistUrl,
        data
      }).then(res => {
        try {
          let {
            list,
            query
          } = res.data.data;
          if (list.length < 10) {
            this.noMoreResult = true;
          }
          if (!list || list.length === 0) {
            this.noMoreResult = true;
            this.bottomLoading = false;
          } else {
            this.pn += 1;
          }
          this.bottomLoading = false;
          this.qalist = [...this.qalist, ...this.formatQalist(list, query)];
        } catch (e) {}
      });
    },
    queryByForm() {
      this.isSelectshow = false;
      this.currentMenu = '';
      if (this.activeTab === 0) {
        this.getSearch();
        if (!this.currentLawQuery) {
          this.emitRelatedRegulation(true);
        } else {
          this.regulationOtherQuestion = false;
        }
      } else {
        this.pn = 1;
        this.noMoreResult = false;
        this.getQalist();
        ubcClickInit({
          page: 'regulations',
          value: 'regulations-search-qa-clk'
        });
      }
    },
    //  搜索法规和法条
    getSearch(type) {
      let log = '';
      const {
        seq_idx = '23002',
        lawid = '9da206b2055f510e284b659a6f6748cb_law_clause'
      } = this.queryParams;
      const data = {
        seq_idx,
        query: this.currentLawQuery || this.word,
        lawid,
        search_source: this.search_source
      };
      // 没有数据重置法规数据
      if (this.currentLawQuery === this.word && this.search_source !== 'launch_law') {
        type !== 'init' && ubcClickInit({
          page: 'regulations',
          value: 'regulations-search-launch-clk'
        });
        return this.getLaunch();
      }
      // 法规卡数据为空的话 推荐对应法条
      if (!this.currentLawQuery) {
        data.query = '';
        if (this.regulations) {
          // 初始化为null
          this.regulations = [];
        }
        this.emitRelatedRegulation(true);
        if (this.currentLawQuery === undefined) {
          // 从首页进来this.currentLawQuery为 undefined
          return Promise.resolve();
        }
      }
      this.isRegulationLoading = true;
      return this.$api.request({
        url: this.searchUrl,
        data
      }).then(res => {
        this.isRegulationLoading = false;
        try {
          let {
            content_info,
            search_title,
            content_count
          } = res.data.data;
          // 后台数据带有search_title 代表是在当前法规搜索 search_source请求参数为launch_clause
          if (search_title) {
            log = 'serp';
            this.searchTitle = search_title;
            this.rules = +content_count ? [search_title, ...content_info] : content_info;
            this.contentCount = +content_count;
          }
          // search_source请求参数为launch_law 代表搜索法规列表
          else {
            log = 'list';
            this.searchTitle = null;
            this.regulationOtherQuestion = false;
            // 搜索法规
            if (Array.isArray(content_info)) {
              if (content_info.length === 0) {
                this.emitRelatedRegulation(true);
              }
              this.regulations = content_info.map(item => {
                item.dynamicTag = this.getDynamicTag(item.timeliness_type);
                item.name = item.name.replace(/\<em\>/g, '<em class="dynamic">');
                return item;
              });
            }
          }
          type !== 'init' && ubcClickInit({
            page: 'regulations',
            value: `regulations-search-${log}-clk`
          });
        } catch (e) {}
      });
    },
    // 动态返回tag类名
    getDynamicTag(type) {
      let dynamicTag = 'valid';
      switch (type) {
        case '1':
          dynamicTag = 'valid';
          break;
        case '2':
          dynamicTag = 'modified-valid';
          break;
        case '3':
          dynamicTag = 'amendment-valid';
          break;
        case '4':
          dynamicTag = 'partial-invalid';
          break;
        case '5':
          dynamicTag = 'invalid';
          break;
        case '6':
          dynamicTag = 'invalid';
          break;
      }
      return dynamicTag;
    },
    // 下拉框点击
    sugItemClick(item) {
      if (this.activeTab === 0) {
        this.currentLawQuery = item.query;
      } else {
        this.currentQaQuery = item.query;
      }
      this.$nextTick(() => {
        this.isSelectshow = false;
      });
      this.queryByForm();
    },
    // 滚动底部 上拉加载问答数据
    onScrollToLower() {
      if (this.noMoreResult) {
        return;
      }
      this.getAsyncQalist();
    },
    // 无限下拉异步问答数据
    getAsyncQalist() {
      if (this.bottomLoading) {
        return;
      }
      this.bottomLoading = true;
      this.updateQaList().then(() => {
        this.bottomLoading = false;
      });
    },
    init() {
      // 初始化url
      this.qalistUrl = reqPathToSearch('async');
      this.searchUrl = reqPathTo('regulation/Search', {}, '', 'law');
      this.otherRegulationUrl = reqPathTo('regulation/query', {}, '', 'law');
      this.otherQaUrl = reqPathTo('content/question/query', {}, '', 'law');
      this.sugUrl = reqPathTo('regulation/sug', {}, '', 'law');
      this.settingUrl = reqPathTo('banner/footbanner', {}, '', 'law');
      this.searcOtherQa();
      let query = this.queryParams.query;
      this.word = this.queryParams.root_query || query;
      this.currentLawQuery = (query && query.query ? query.query : query) || '';
      this.getSearch('init').then(() => {
        setTimeout(() => {
          this.currentMenu = `active-${this.queryParams.index}`;
        }, this.rules.length);
      });
      this.getSetting();
    },
    // 目录点击
    changeCatalogueShow() {
      ubcClickInit({
        page: 'regulations',
        value: 'regulations-catalog-clk'
      });
      this.isCatalogueShow = !this.isCatalogueShow;
    },
    // tab切换
    tabClick(index) {
      this.activeTab = index;
      this.isSelectshow = false;
      if (index === 1) {
        sendUbcShowLog({
          page: 'regulations',
          value: 'regulations-qa-show'
        });
      }
    },
    // 章节点击进行定位
    contentsClick(item) {
      this.currentMenu = 'active-' + item.index;
      this.changeCatalogueShow();
    },
    // 关闭底部弹层
    closePopUp() {
      this.showNoMorePop = false;
    },
    bindscrolltolower() {
      if (this.search_source === 'launch_clause' && this.rules.length) {
        this.showNoMorePop = true;
      }
    },
    turnIm() {
      act({
        target: this.bannerAd.url
      });
    }
  },
  created() {
    (function () {
      // if (!this.isRunMain) {
      //     this.isRunMain = true;
      //     this.queryParams = ctx;
      //     this.search_source = ctx.searchSource || 'launch_clause';
      //     if (this.search_source === 'launch_law') {
      //         if ("h5" === 'h5') {
      //             this.currentLawQuery = (ctx.query && ctx.query.query ? ctx.query.query : ctx.query) || '';
      //         }
      //         else {
      //             this.currentLawQuery = ctx.query || '';
      //         }
      //         this.$nextTick(() => {
      //             this.isSelectshow = false;
      //         });
      //     }
      //     this.init(ctx);
      // }
    }).call(this, this.$route.query);
    (function () {
      nav({
        type: 'redirect',
        url: '/pages/error/notFound?fr=regulations'
      });
      // if (!this.isRunMain) {
      //     this.isRunMain = true;
      //     this.queryParams = ctx;
      //     this.search_source = ctx.searchSource || 'launch_clause';
      //     if (this.search_source === 'launch_law') {
      //         if ("h5" === 'h5') {
      //             this.currentLawQuery = (ctx.query && ctx.query.query ? ctx.query.query : ctx.query) || '';
      //         }
      //         else {
      //             this.currentLawQuery = ctx.query || '';
      //         }
      //         this.$nextTick(() => {
      //             this.isSelectshow = false;
      //         });
      //     }
      //     this.init(ctx);
      // }
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    } // inSightObserverDisconnects();
    ).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    } // setPageInfoMenu({title: '律临法律服务_法律法规'});
    ).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.regulate {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.regulate .top {
  position: relative;
}
.regulate .content {
  flex: 1;
  height: fit-content;
  overflow: auto;
  background: #f5f5f5;
}
.regulate .content .content-articles {
  height: 100%;
  background: #fff;
}
.regulate .content .content_law {
  background: transparent;
}
.regulate .content .content-qa {
  height: 100%;
  background: #fff;
}
.regulate .content .scroll-view {
  height: 100%;
  box-sizing: content-box;
  background: #fff;
}
.regulate .content .scroll-view .regulations-promt {
  height: 100%;
}
.regulate .content .scroll-view .is-init {
  height: auto;
  background: #fff;
}
.regulate .content .scroll-view .has-data {
  height: 100%;
  background: #f5f5f5;
}
.regulate .content .scroll-view .has-data /deep/ [class*="qa-containter"] {
  height: 100%;
  background: #f5f5f5;
}
.regulate .content .scroll-view .white /deep/ .no-content {
  color: #fff;
  height: 0;
  padding: 0;
  margin: 0;
  background: #fff;
}
.regulate .content .scroll-view .scroll-warpper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.regulate .contanter .fixed-top {
  padding-bottom: 20px;
}
.regulate .contanter .tab {
  padding: 0 17px;
  display: flex;
  justify-content: space-around;
  line-height: 32px;
  color: #555;
  font-size: 16px;
  margin-top: 10px;
}
.regulate .contanter .tab .tab-item {
  position: relative;
  width: 50%;
  text-align: center;
}
.regulate .contanter .tab .tab-item .select {
  position: absolute;
  width: 63px;
  border-radius: 5px;
  height: 4px;
  background: #445fbb;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
}
.regulate .contanter .bar {
  padding: 0 17px;
  margin-top: 26px;
  font-size: 14px;
}
.regulate .contanter .bar input {
  height: 42px;
  line-height: normal;
  border: 1px solid #b8b8b8;
  border-radius: 9px;
  padding-left: 12px;
  padding-right: 30px;
  box-sizing: border-box;
  outline: none;
  font-size: 14px;
  font-weight: 700;
}
.regulate .contanter .bar input::-webkit-input-placeholder {
  font-weight: 400;
  color: #858585;
}
.regulate .contanter .bar .placeholder {
  font-weight: 400!important;
  color: #858585 !important;
}
.regulate .contanter .bar .btn {
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(31, 31, 31, 0.5);
  border-radius: 9px;
  text-align: center;
  color: #1f1f1f;
  font-weight: 700;
}
.regulate .contanter .bar .clear-btn {
  position: absolute;
  right: 14px;
  top: 0;
  width: 18px;
  height: 22px;
  padding: 10px 0 10px 10px;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDhweCIgaGVpZ2h0PSI0OHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5b2i54q2PC90aXRsZT4KICAgIDxnIGlkPSLpobXpnaItMiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTI0LDAgQzM3LjI1NDgzNCwwIDQ4LDEwLjc0NTE2NiA0OCwyNCBDNDgsMzcuMjU0ODM0IDM3LjI1NDgzNCw0OCAyNCw0OCBDMTAuNzQ1MTY2LDQ4IDAsMzcuMjU0ODM0IDAsMjQgQzAsMTAuNzQ1MTY2IDEwLjc0NTE2NiwwIDI0LDAgWiBNMzEuNjMxODEwMiwxMy44NTQwMzI0IEwyNCwyMS40ODYgTDE2LjM2ODE4OTgsMTMuODU0MDMyNCBMMTMuODU0MDMyNCwxNi4zNjgxODk4IEwyMS40ODYsMjQgTDEzLjg1NDAzMjQsMzEuNjMxODEwMiBMMTYuMzY4MTg5OCwzNC4xNDU5Njc2IEwyNCwyNi41MTQgTDMxLjYzMTgxMDIsMzQuMTQ1OTY3NiBMMzQuMTQ1OTY3NiwzMS42MzE4MTAyIEwyNi41MTQsMjQgTDM0LjE0NTk2NzYsMTYuMzY4MTg5OCBMMzEuNjMxODEwMiwxMy44NTQwMzI0IFoiIGlkPSLlvaLnirYiIGZpbGw9IiNCOEI4QjgiPjwvcGF0aD4KICAgIDwvZz4KPC9zdmc+') no-repeat;
  background-position: center right;
  background-size: 18px 18px;
}
.regulate .contanter .recommend-select {
  position: absolute;
  padding: 0 23px;
  background: #fff;
  line-height: 42px;
  z-index: 1;
  overflow: auto;
  height: calc(100vh - 155px);
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  color: #252525;
  box-sizing: border-box;
}
.regulate .contanter .recommend-select .recommend-select-item:not(:last-child) {
  border-bottom: 0.5px solid #e0e0e0;
}
.regulate .contanter .recommend-select .query-strong,
.regulate .contanter .recommend-select /deep/ em {
  color: #222;
  font-weight: 700;
  font-family: Arial, Helvetica, sans-serif;
  text-decoration: none;
  font-style: normal;
}
.regulate .contanter .recommend-select [class*="query-strong"] {
  color: #222;
  font-weight: 700;
  font-family: Arial, Helvetica, sans-serif;
  text-decoration: none;
  font-style: normal;
}
.regulate .contanter .active {
  color: #222;
  font-weight: 700;
}
.regulate .catalogue-btn {
  height: 40px;
  line-height: 40px;
  border: 1px solid rgba(31, 31, 31, 0.5);
  border-radius: 9px;
  text-align: center;
  color: #1f1f1f;
  font-weight: 700;
}
.regulate .noscroll {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  z-index: 0;
}
.regulate .bottombar {
  z-index: 9;
  box-shadow: 0 0 7px 0 rgba(0, 56, 68, 0.08);
}
.regulate .bottombar /deep/ .bottom-bar-counsel-single {
  border: 1px solid rgba(68, 95, 187, 0.8);
  color: #445fbb;
  width: 186px;
}

</style>
